import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';

// @TODO This likely won't be an action but a mutation
export function formSubmitted(state: WritableDraft<QuoteBuilderStateType>) {
  console.log(state);
}
